<div id="pdf-viewer-container" class="container">
  <div class="error" *ngIf="!path || pdfFailed">
    <img [src]="'assets/icons/document-error.svg'" />
    <p>No se ha podido cargar el archivo PDF</p>
  </div>
  <ngx-extended-pdf-viewer
    #mypdf
    id="mypdf"
    useBrowserLocale="false"
    delayFirstView="1000"
    [height]="'100%'"
    [src]="path"
    [useBrowserLocale]="true"
    [handTool]="false"
    [showHandToolButton]="true"
    [spread]="true"
    [showOpenFileButton]="false"
    (pdfLoadingFailed)="onPdfLoadingFailed()"
    *ngIf="path && !pdfFailed"
  ></ngx-extended-pdf-viewer>
</div>
